/*
    String
 */
String.prototype.ucfirst = function () {
    return this.substring(0, 1).toUpperCase() + this.substring(1);
};

String.prototype.lcfirst = function () {
    return this.substring(0, 1).toLowerCase() + this.substring(1);
};

String.prototype.withDot = function () {
    if (this.endsWith('.')) {
        return this;
    }

    return this + '.';
};

String.prototype.requestParameterToCamelCase = function () {
    let parts = this.split('_');

    return parts.map(part => part.ucfirst())
        .join('')
        .lcfirst();
};

/*
   Array
 */
Object.defineProperty(Array.prototype, "removeElement", {
    enumerable: false,
    value: function(elementToRemove) {
        let elementIndex = this.indexOf(elementToRemove);
        if (elementIndex !== -1) {
            this.splice(elementIndex, 1);
        }

        return this;
    }
});

Object.defineProperty(Array.prototype, "pushUnique", {
    enumerable: false,
    value: function(elementToAdd) {
        if (!this.includes(elementToAdd)) {
            this.push(elementToAdd);
        }

        return this;
    }
});

Object.defineProperty(Array.prototype, "isEmpty", {
    enumerable: false,
    value: function() {
        return this.length === 0;
    }
});

Object.defineProperty(Array.prototype, "isNotEmpty", {
    enumerable: false,
    value: function()  {
        return this.length > 0;
    }
});

/*
    Date
 */
Date.prototype.toDateTimeInputFormat = function () {
    return this.toISOString().replace(/\.\d+Z$/, '');
};
